

export const isTop10ClassificationSocieties = (classification_society?: string | null) => {
    /**
     * '美国船级社（ABS）','挪威船级社（DNV）','法国船级社（BV）','德国船级社（GL）','劳埃德船级社（LR）','中国船级社（CCS）','日本船级社（NK）','意大利船级社（RINA）','俄罗斯船级社（RS）','印度船级社（IRS）'
     * 船级社字段包含以上的就是十大船级社,因为船级社展示的是处理过的，能处理的都会展示成上面的格式，但是有的会有多个船级社比如这样挪威船级社（DNV）/越南船级社（VR）
     * @author: Junxiang
     * @date: 2024-08-20
     */
  
    if (!classification_society) return false
  
    const splited = classification_society.split('/')
    const isTop10 = splited.some((item) => {
      return [
        '美国船级社（ABS）',
        '挪威船级社（DNV）',
        '法国船级社（BV）',
        '德国船级社（GL）',
        '劳埃德船级社（LR）',
        '中国船级社（CCS）',
        '日本船级社（NK）',
        '意大利船级社（RINA）',
        '俄罗斯船级社（RS）',
        '印度船级社（IRS）',
      ].includes(item)
    })
    return isTop10
  }
